import { toast } from 'react-toastify';
import { TOKEN_EXPIRED } from './types';

export const axiosConfig = {
  headers: { 'Content-Type': 'application/json' },
  validateStatus(status) { return status < 400; },
};

export const ThrowErrorMsg = (err, dispatch) => {
  if (err.response) {
    if (err.response.status === 401) {
      toast.error('Token Expired');
      dispatch({ type: TOKEN_EXPIRED });
    } else { throw err.response.data; }
  } else {
    throw err.message;
  }
};
